import React from 'react'

// svg
import star from '../Assets/star.svg';
import twoHalfCircle from '../Assets/two-half-circle.svg';
import line from '../Assets/Line.png';
import num1 from '../Assets/number-1.png';
import num2 from '../Assets/number-2.png'
import num3 from '../Assets/number-3.png'

const HowItWorks: React.FC = () => {
  return (
    <section id='how-it-works' className='py-16 md:pt-24 md:pb-12 relative'>
      <img src={star} alt='' className='absolute top-52 md:top-30  md:left-0 lg:left-14 hidden md:block md:w-[40px]' />
      <img src={twoHalfCircle} alt='' className='absolute right-12 md:top-80 hidden md:block md:w-[40px]' />
      <div className='container'>
        <h2 className=' text-darkText text-[30px] md:text-[36px] text-center font-bold mb-12'>How Examcompass Works</h2>
        <div className='w-full md:w-[660px] mx-auto'>
          <div className='flex gap-4  md:gap-16 mb-4'>
            <div className='flex flex-col items-center gap-3'>
              <img className='w-[40px]' src={num1} alt='Number 1' />
              <img className='h-[65px]' src={line} alt='Line' />
            </div>
            <div className='md:w-[550px]'>
              <p className='text-darkText text-[20px] lg:text-[25px] font-semibold mb-2'>Start Learning with Tailored Notes</p>
              <p className='text-textColor text-[16px]'>Access structured notes aligned with the UTME syllabus for all your subjects.</p>
            </div>
          </div>

          <div className='flex gap-4 md:gap-16 mb-4'>
            <div className='flex flex-col items-center gap-3'>
              <img className='w-[40px]' src={num2} alt='Number 1' />
              <img className='h-[65px]' src={line} alt='Line' />
            </div>
            <div>
              <p className=' text-darkText text-[20px] lg:text-[25px] font-semibold mb-2'>Test Your Knowledge with Quizzes</p>
              <p className='text-textColor text-[16px]'>Complete quizzes to reinforce learning and unlock the next module.</p>
            </div>
          </div>

          <div className='flex gap-4 md:gap-16'>
            <div className='flex flex-col items-center'>
              <img className='w-[40px]' src={num3} alt='Number 1' />
            </div>
            <div>
              <p className=' text-darkText text-[20px] lg:text-[25px] font-semibold mb-2'>Achieve More Through Competitions</p>
              <p className='text-textColor text-[16px]'>Join live national challenges, win prizes, and earn leaderboard recognition.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks